import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

export interface ConsequenceRowProps {
  label: ReactNode;
  value: ReactNode;
  /** The figure the decision turns on — larger, in the foreground colour. */
  emphasis?: boolean;
}

export function ConsequenceRow({ label, value, emphasis = false }: ConsequenceRowProps) {
  return (
    <div
      className={cn(
        "flex items-baseline justify-between gap-4 py-2",
        emphasis && "border-t border-border pt-3",
      )}
    >
      <span className={cn("text-sm", emphasis ? "font-medium text-foreground" : "text-muted-foreground")}>
        {label}
      </span>
      <span className={cn("text-right", emphasis ? "text-foreground" : "text-sm text-foreground")}>
        {value}
      </span>
    </div>
  );
}

/** The bordered box a money-moving dialog opens with: the figures, then the warnings, then the checkboxes. */
export function ConsequenceList({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn("rounded-lg border border-border bg-muted/30 px-4 py-1", className)}>{children}</div>
  );
}
